module.exports = __webpack_public_path__ + "img/video-default-thumbnail.f7b203bd.jpg";